import "./FindUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactInformation from "./sections/ContactInformation";
import MapAndDirections from "./sections/MapAndDirections";
import CollegamentiSocial from "./sections/CollegamentiSocial";
import Footer from "@/reusable_sections/Footer";
import Contact from "./sections/Contact";
import MailAndCorrespondence from "./sections/MailAndCorrespondence";
import InfoColumns from "./sections/InfoColumns";
import HowItWorks from "./sections/HowItWorks";
export default function FindUsPage() {
  return <div>
      <Header />
      <ContactInformation />
      <InfoColumns />
      <HowItWorks />
      <MapAndDirections />
      <Contact />
      <MailAndCorrespondence />
      <CollegamentiSocial />
      <Footer />
    </div>;
}